import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import RequireAuth from '../components/RequireAuth';
import CashierLayout from './CashierLayout';
import { readCashierLocationId } from './lib/prefs';
import CashierBoardPage from './pages/CashierBoardPage';
import CashierLedgerPage from './pages/CashierLedgerPage';
import CashierNewOrderPage from './pages/CashierNewOrderPage';
import CashierOfflinePage from './pages/CashierOfflinePage';
import CashierOrderPage from './pages/CashierOrderPage';
import CashierScanPage from './pages/CashierScanPage';
import CashierSettingsPage from './pages/CashierSettingsPage';

/**
 * `/cashier/*` 八条路由（§3.4 冻结的六条 + Phase 9 新增的两条）。
 *
 * **必须挂在 `AppLayout` 之外**：收银端自带顶栏与底部 tab，套进管理端侧边栏后
 * PWA 全屏安装形态会同时出现两套导航（而 `start_url` 就是 `/cashier`）。
 *
 * Phase 9 的两条（`05-ui-design-system.md` §3.3）：
 *   · `/cashier/offline` —— 待上传队列（`order:accept`；状态条上的「查看」指向它，
 *     也是「恢复联网」之后店员核对补传结果的地方）；
 *   · `/cashier/ledger` —— 账本（复用社团后台的同一份账本页，见 `CashierLedgerPage`）。
 *     两条都**不新增权限键**（Phase 8 的 A-P8-19 家族：新增一个要同步三处）。
 */
function ShelfRedirect() {
  const locationId = readCashierLocationId();
  // 收银端货架页需要 `:id`，而 §3.4 的六条路由里没有对应页面文件（现有 LocationShelvesPage
  // 读的是 `useParams().id`）⇒ 先跳管理端的货架页（附录 A25：不重复实现一遍货架管理）。
  // Phase 6 补 `/cashier/shelf/:row/:col` 深链。
  return <Navigate to={locationId === null ? '/locations' : `/locations/${locationId}/shelves`} replace />;
}

export const CASHIER_ROUTES: RouteObject[] = [
  {
    path: '/cashier',
    element: (
      <RequireAuth>
        <CashierLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <CashierBoardPage /> },
      { path: 'orders/:orderNo', element: <CashierOrderPage /> },
      { path: 'scan', element: <CashierScanPage /> },
      { path: 'new', element: <CashierNewOrderPage /> },
      { path: 'offline', element: <CashierOfflinePage /> },
      { path: 'ledger', element: <CashierLedgerPage /> },
      { path: 'shelf', element: <ShelfRedirect /> },
      { path: 'settings', element: <CashierSettingsPage /> },
    ],
  },
];
